"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowManager = void 0;
const rxjs_1 = require("rxjs");
class WindowManager {
    constructor(canvas, VIEWPORT_VS_CLIENT_HEIGHT_RATIO = 0.75) {
        this.canvas = canvas;
        this.VIEWPORT_VS_CLIENT_HEIGHT_RATIO = VIEWPORT_VS_CLIENT_HEIGHT_RATIO;
        this.$orientChange = new rxjs_1.BehaviorSubject(this.isPortrait);
        this.orientationlistener = (event) => {
            this.$orientChange.next(this.isPortrait);
        };
        this.touchstart = (ev) => {
            if (ev.touches.length === 1) {
                ev.preventDefault();
                // const touch = ev.touches[0];
                // if (touch.clientX < window.innerWidth * 0.1 || touch.clientX > window.innerWidth * 0.9) {
                //     ev.preventDefault();
                // }
            }
        };
        this.keyboardopen = false;
        this.keyboardlistener = (event) => {
            var _a;
            const target = (event.target);
            let calc;
            let tar;
            if (this.isPortrait) {
                calc = (target.height * target.scale) / window.screen.height;
                tar = (window.innerHeight - target.height * target.scale);
            }
            else {
                calc = (target.width * target.scale) / window.screen.width;
                tar = (window.innerWidth - target.width * target.scale);
            }
            if (calc < this.VIEWPORT_VS_CLIENT_HEIGHT_RATIO) {
                this.keyboardopen = true;
                if (this.canvas && ((_a = WindowManager.focusField) === null || _a === void 0 ? void 0 : _a.moveWhenEditing) && this.keyboardOverlays) {
                    this.canvas.style.position = 'relative';
                    this.canvas.style.bottom = tar + 'px';
                }
            }
            else {
                if (this.keyboardopen && this.canvas) {
                    this.canvas.style.position = 'relative';
                    this.canvas.style.bottom = '0px';
                }
                this.keyboardopen = false;
            }
        };
        if ('visualViewport' in window) {
            window.visualViewport.addEventListener('resize', this.keyboardlistener);
        }
        if (window === null || window === void 0 ? void 0 : window.addEventListener) {
            window.addEventListener('orientationchange', this.orientationlistener, false);
            window.addEventListener('touchstart', this.touchstart, { passive: false });
        }
    }
    get isPortrait() {
        return !!(window === null || window === void 0 ? void 0 : window.matchMedia("(orientation: portrait)").matches);
    }
    get keyboardOverlays() {
        if ("virtualKeyboard" in navigator) {
            return (navigator.virtualKeyboard).overlaysContent;
        }
        return (/iPad|iPhone|iPod/.test(navigator.userAgent));
    }
    get isLandscape() {
        return !this.isPortrait;
    }
    destroy() {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener('resize', this.keyboardlistener);
        window === null || window === void 0 ? void 0 : window.removeEventListener('orientationchange', this.orientationlistener);
        window === null || window === void 0 ? void 0 : window.removeEventListener('touchstart', this.touchstart);
    }
}
exports.WindowManager = WindowManager;
WindowManager.focusField = null;
